import React from 'react';
import classNames from 'classnames';
import { classes } from './field-label-wut.st.css';
export const FieldLabelWUT = _ref => {
  let {
    labelId,
    htmlFor,
    label,
    required = false,
    hideLabel = false,
    hideAsterisk = false
  } = _ref;
  const Tag = htmlFor ? 'label' : 'div';
  return /*#__PURE__*/React.createElement(Tag, {
    id: labelId,
    htmlFor: htmlFor,
    className: classNames(classes.label, {
      [classes.hidden]: hideLabel
    })
  }, label, required && !hideAsterisk && /*#__PURE__*/React.createElement("span", {
    className: classes.asteriskMargin,
    "aria-hidden": "true"
  }, "*"));
};
//# sourceMappingURL=field-label-wut.js.map